import React, { useState, useLayoutEffect, useEffect } from "react";

export default function GoogleMap() {
  return (
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4479.79457979669!2d-4.426574!3d55.847097!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48884937dbb84397%3A0xaf9fee5343bf12e!2s3%20Hunter%20St%2C%20Paisley!5e0!3m2!1sen!2suk!4v1593369030870!5m2!1sen!2suk"
      width="100%"
      height="450px"
      frameBorder="0"
      style={{ border: 0 }}
      allowFullScreen={false}
      aria-hidden="false"
      tabIndex={0}
    ></iframe>
  );
}
